// React Query client.
//
// Every failed query and mutation is reported (src/lib/errorReporter.ts), so a
// save that fails for a user leaves a record with the message they saw — the
// server logs alone cannot show failures that never reach the server.

import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { reportError } from '@/lib/errorReporter';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportError('query', error, { queryKey: JSON.stringify(query.queryKey).slice(0, 300) });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      reportError('mutation', error, {
        mutationKey: mutation.options.mutationKey ? JSON.stringify(mutation.options.mutationKey).slice(0, 300) : null,
        fn: mutation.options.mutationFn?.name || null,
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
